export default __webpack_public_path__ + "static/blogThumbnail(2)-6ee6f9a354a00f82711b8c5ab252e855.png";